import service from '@/utils/request'
//定时任务api


//查询所有定时任务
export function queryAll(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/queryAll',
		data: param,
	})
}

//新增定时任务
export function saveJob(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/saveJob',
		data: param,
	})
}
//更新定时任务
export function editJob(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/editJob',
		data: param,
	})
}
// 立即运行
export function runJob(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/runJob',
		data: param
	})
}
// 删除定时任务
export function delJob(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/delJob',
		data: param
	})
}

// 开启
export function resumeJob(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/resumeJob',
		data: param
	})
}

// 暂停
export function pauseJob(param) {
	return service.request({
		method: 'post',
		url: '/app/quartzJob/pauseJob',
		data: param
	})
}
